import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import {
  Autocomplete,
  Button,
  TextField,
  Radio,
  RadioGroup,
  FormHelperText,
  FormControl,
  FormControlLabel,
  Switch,
  Box,
  Tooltip,
  Chip,
  Grid,
  Typography,
  IconButton
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PatchedReactQuill from "./PatchedReactQuill.tsx";
import {
  ApiGetClientEntities,
  ApiPostCreateVenue,
  ApiPutUpdateVenue,
  ApiGetShopType,
  ApiGetStarRating,
  ApiGetBriefJson,
  ApiGetClientEntitiTemplate,
  ApiGetManageRegions,
  ApiCopyLogo,
  ApiCopyDateRequest,
  ApiGetVenueList,
  ApiGetAreaManager,
} from "../../../apiService/Core/Apicall.tsx";
import * as Yup from "yup";
import { CustomUploadProfilePic } from "../../../apiService/Core/CustomUploadProfilePic.tsx";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../../global/config/Action/loadingActions.ts";
import store, { RootState } from "../../../global/config/store.ts";
import imageCompression from "browser-image-compression";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import {
  DndContext,
  closestCenter,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { CancelOutlined, DescriptionOutlined, InfoOutlined, InsertDriveFileOutlined, PictureAsPdfOutlined, Upload } from "@mui/icons-material";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: -25.2744,
  lng: 133.7751,
};

interface AddOrUpdateVenueProps {
  initialValues?: {
    venueName: string;
    venueCode: string;
    entityName: string;
    hotelType: string;
    territory: string;
    contact: string;
    address: string;
    suburb: string;
    state: string;
    country: string;
    postCode: string;
    phone: string;
    fax: string;
    email: string;
    feedbackEmail: string;
    auditEmail: string;
    fixItEmail: string;
    reportEmail: string;
    description: string;
    shopType: string;
    email2: string;
    jobType: string;
    tradingHours: string;
    venueAdditionalInfo: string;
    website: string;
    venuePrice: string;
    venuePriceDisplay: string;
    pdfDescription: string;
    briefJson: string;
    areaIds:string;
    lat: number;
    long: number;
    starRatings: string;
    venueLogo: string | File;
    locationType: string;
    sampleReportUrl: string
  };
  mode: "add" | "update";
  onSubmit: (values: any) => void;
}

interface FormValues {
  entityName: string;
  hotelType: string;
  venueName: string;
  venueCode?: string;
  contact: string;
  email: string;
  locationType: string;
  venuePrice: string;
}

interface Region {
  label: string;
  value: number;
}

const SortableChip = ({ id, label, onDelete }: any) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: "grab",
  };

  return (
    <Chip
      ref={setNodeRef}
      style={style}
      {...attributes}
      label={
        <span {...listeners} style={{ cursor: 'grab' }}>
          {label}
        </span>
      }
      onDelete={onDelete}
      sx={{ cursor: 'default' }}
    />
  );
};

const sanitizeEditorContent = (content: any) => {
  if (!content) return "";

  let cleaned = content
    .replace(/<p><br\s*\/?><\/p>/gi, '')
    .replace(/<p>\s*<\/p>/gi, '')
    .replace(/<br\s*\/?>/gi, '')
    .trim();

  const textOnly = cleaned.replace(/<[^>]*>/g, '').trim();
  return textOnly.length === 0 ? "" : cleaned;
}

const AddOrUpdateVenue: React.FC<AddOrUpdateVenueProps> = () => {
  const { mode, id } = useParams<{ mode: "add" | "update"; id?: string }>();
  const location = useLocation();
  // const venue = location?.state?.venueData;
  const [venue, setVenue] = useState<any>([])
  // const [Latitude, setLatitude]= useState();
  // const [Longitude, setLongitude]= useState();
  // const Longitude = Number(venue?.long);
  const [latNew, setLat] = useState<number>(0);
  const [lngNew, setLng] = useState<number>(0);
  const [hotelType, setHotelType] = useState<any>("");
  const [regionName, setRegionName] = useState<any>();
  const [entityName, setEntityName] = useState<any>("");
  const [formValues, setFormValues] = useState<any>({
    venueName: "",
    venueCode: "",
    entityName: entityName,
    hotelType: hotelType,
    territory: "",
    contact: "",
    address: "",
    state: "",
    country: "",
    suburb: "",
    postCode: "",
    phone: "",
    fax: "",
    email: "",
    feedbackEmail: "",
    auditEmail: "",
    fixItEmail: "",
    reportEmail: "",
    description: "",
    shopType: "",
    email2: "",
    jobType: "",
    tradingHours: "",
    venueAdditionalInfo: "",
    website: "",
    venuePrice: "",
    venuePriceDisplay: "",
    director: "",
    executiveManager: "",
    pdfDescription: "",
    briefJson: "",
    areaIds:'',
    starRatings: "",
    venueLogo: "",
    locationType: "",
    isAutoApproveDateChange: false,
    isEnableManagerScenarioDiscussion: false,
    venueOpen: "",
    venueClose: "",
  });
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const dispatch = useDispatch()
  const [clientEntity, setClientEntity] = useState([]);
  const [entityType, setEntityType] = useState<any[]>([]);
  const [editorValue, setEditorValue] = useState<any>("");
  const [venueMessage, setVenueMessage] = useState<any>("");
  const [preview, setPreview] = useState<string | null>(null);
  const [starRatingList, setStarRating] = useState<any>([]);
  const navigate = useNavigate();
  const [briefJsonNew, setBriefJson] = useState<any>([]);
  const [areaList, setAreaList] = useState<any>([]);
  const [logoUrl, setLogoUrl] = useState<any>();
  const [mapAddress, setAddress] = useState<any>();
  const inputRef = useRef<HTMLInputElement>(null);
  const autocompleteRef = useRef<any>(null);
  const setFieldValueRef = useRef<any>(null);
  const [regions, setRegions] = useState<Region[]>([]);
  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
  const [ClientId, setClientId] = useState(selectedClientName?.clientGroupName)
  const [venueOpenDate, setVenueOpenDate] = useState<Date | null>(null);
  const [venueCloseDate, setVenueCloseDate] = useState<Date | null>(null);
  const [uploadedFiles, setUploadedFiles] = useState<string[]>([]);



  // useEffect(() => {
  //   if (Clientlist.length > 2) {
  //     // setSelectedClient(Clientlist[2])
  //     setClientId(Clientlist[2].clientGroupName)
  //   }
  // }, [Clientlist])
  const handleGetVenueList = async () => {
    const data = `?venueId=${id}`;
    try {
      const response: any = await ApiGetVenueList(data);
      // const transformedData = response.data.map((item: any) => ({
      //   value: item.venueId,
      //   label: item.venueName,
      // }));
      setVenue(response?.data[0]);
      setLat(Number(response?.data[0]?.lat))
      setLng(Number(response?.data[0]?.long))
      setUploadedFiles(response.data[0].sampleReportUrl.split(",").filter(Boolean))
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    if (id) {
      handleGetVenueList()
    }
  }, [id])


  useEffect(() => {
    if (mode === "update" && venue) {
      // setEditorValue(venue.venueDescription || "");
      setVenueMessage(venue.venueMessage || "");
      setHotelType(venue?.shopTypeId?.shopTypeId || "");
      setEntityName(venue?.clientEntityId?.clientEntityId || "");
      setClientId(venue?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName || '')
      setVenueOpenDate(venue.venueOpen ? new Date(venue.venueOpen) : null);
      setVenueCloseDate(venue.venueClose ? new Date(venue.venueClose) : null);
      // setSelectedClient(
      //   Clientlist.find(
      //     item => item.clientGroupName === venue?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName
      //   ) || ''
      // );
      setLogoUrl(venue?.logoUrl || "");
      setFormValues({
        venueName: venue.venueName || "",
        venueCode: venue.venueCode || "",
        entityName: venue?.clientEntityId?.clientEntityId || "",
        contact: venue.contactNo || "",
        address: venue.address || "",
        city: venue.city || "",
        state: venue.state || "",
        postalCode: venue.postalCode || "",
        email: venue.emailId || "",
        country: venue.country || "",
        briefJson: venue.briefJson || "",
        areaIds: venue.areas?.map((area:any)=>area?.areaId)?.join(",") || "",
        starRatings: venue.starRating || "",
        feedbackEmail: venue.feedbackEmail || "",
        auditEmail: venue.auditEmail || "",
        fixItEmail: venue.fixItEmail || "",
        reportEmail: venue.reportEmail || "",
        // venueDescription: venue.venueDescription || "",
        tradingHours: venue.tradingHours || "",
        venueAdditionalInfo: venue.venueAdditionalInfo || "",
        website: venue.websiteURL || "",
        venuePrice: venue.venuePrice || "",
        venuePriceDisplay: venue.venuePriceDisplay || "",
        venueNo: venue.venueNumber || "",
        venueGroup: venue.venueGroup || "",
        director: venue.directorName || "",
        executiveManager: venue.executiveManager || "",
        pdfDescription: venue.pdfDescription || "",
        hotelType: venue?.shopTypeId?.shopTypeId || "",
        locationType: venue.locationType || "",
        isAutoApproveDateChange: venue.isAutoApproveDateChange || false,
        venueOpen: venue.venueOpen || "",
        venueClose: venue.venueClose || "",
        isEnableManagerScenarioDiscussion: venue.isEnableManagerScenarioDiscussion || false,
      });
      setRegionName(venue?.regionId?.regionId);
    }
  }, [mode, id, venue, lngNew, latNew]);


  useEffect(() => {
    ClientId && handleGetApiCallClientEntity();
    handleGetApiCallEntityType();
    handelApiGetStarRating();
    handleGetEditType();
    handleGetRegions();
    // handleGetAreaManagers();
  }, [venue, mode, ClientId, selectedClient]);

  useEffect(()=>{
    console.log("ENtity Name", entityName)
   entityName && handleGetAreaManagers();
  },[entityName])
  useEffect(() => {
    setSelectedClient(selectedClientName)
    setClientId(selectedClientName?.clientGroupName)
  }, [selectedClientName])

  useEffect(() => {
    const loadAutocomplete = async () => {
      // Add a small delay to ensure the input is rendered
      setTimeout(() => {
        if (!window.google) {
          console.error("Google Maps API is not loaded.");
          return;
        }

        if (!inputRef.current) {
          console.error("Input reference is null.");
          return;
        }

        try {
          autocompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            {
              types: ["geocode"],
              componentRestrictions: { country: "AU" },
            }
          );

          autocompleteRef.current.addListener("place_changed", async () => {
            const place = autocompleteRef.current.getPlace();

            if (!place || !place.formatted_address) {
              console.warn("No address found.");
              return;
            }

            // Update the address field value using setFieldValue
            if (setFieldValueRef.current) {
              setFieldValueRef.current("address", place.formatted_address);
            }

            // Store the full place object for address components
            setAddress(place);

            if (place.geometry?.location) {
              setLat(place.geometry.location.lat());
              setLng(place.geometry.location.lng());
            }
          });
        } catch (error) {
          console.error("Error initializing autocomplete:", error);
        }
      }, 100);
    };

    loadAutocomplete();
  }, []);

  const handleGetEditType = async () => {
    const data = "?offset=0&limit=500"
    try {
      const response: any = await ApiGetBriefJson(data);
      if (Array.isArray(response.data)) {
        const transformedData = response.data.map((item: any) => ({
          value: item.briefJsonId,
          label: item.briefJsonTitle,
          min: item.minNoOfWords,
          max: item.maxNoOfWords,
          description: item?.briefJsonDescription
        }));
        setBriefJson(transformedData);
      } else {
        console.error("Unexpected data format:", response.data);
        setBriefJson([]);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setBriefJson([]);
    }
  };
  const handleGetAreaManagers = async () => {
    if(!entityName) return;
    try {
      let data = `?offset=0&limit=500&clientGroupName=${selectedClient?.clientGroupName}&clientEntityId=${entityName}`
          const response = await ApiGetAreaManager(data)
      if (Array.isArray(response.data)) {
        const transformedData = response.data.map((item: any) => ({
          value: item.areaId,
          label: item.areaName,
          firstName: item.firstName,
          lastName: item.lastName,
          emailId: item?.emailId
        }));
        setAreaList(transformedData);
      } else {
        console.error("Unexpected data format:", response.data);
        setAreaList([]);
      }
    } catch (error) {
      console.error("Error during API call:", error);
      setAreaList([]);
    }
  };

  const handelApiGetStarRating = async () => {
    try {
      const data = `?offset=0&limit=1000`
      const response: any = await ApiGetStarRating(data);
      setStarRating(
        response.data.map((starRating: any) => ({
          label: starRating.starRatingDesc,
          value: starRating.starRatingId,
          isDisabled: starRating.isDisabled
        }))
      );
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleGetRegions = async () => {
    try {
      const response: any = await ApiGetManageRegions();
      const transformed = response.data.map((item: any) => ({
        value: item.regionId,
        label: item.regionName,
      }));
      setRegions(transformed);
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
  };

  const handleGetApiCallClientEntity = async () => {
    const data = `?offset=0&limit=100&clientEntityStatus=active${ClientId ? `&clientGroupName=${ClientId}` : ''}`;
    try {
      const response: any = await ApiGetClientEntities(data);
      setClientEntity(
        response.data.map((clientEntity: any) => ({
          label: clientEntity.entityName,
          value: clientEntity.clientEntityId,
        }))
      );
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleEntityChange = async (newValue) => {
    try {
      if (!newValue) return; // Prevent errors if value is cleared
      setEntityName(newValue.value);
      const data = `?clientEntityId=${newValue.value}`;
      const response = await ApiGetClientEntitiTemplate(data);
      if (response.data.length === 0) {
        toast.error("Please add job crieteria for this business");
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleGetApiCallEntityType = async () => {
    try {
      const response: any = await ApiGetShopType();
      const transformedData = response.data.map((item: any) => ({
        value: item.shopTypeId,
        label: item.shopTypeName,
      }));
      setEntityType(transformedData);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleAddVenue = async (values: any) => {
    // Extracting values from address_components
    const components = mapAddress?.address_components;

    const getComponent = (type: string) =>
      components?.find((c) => c.types?.includes(type))?.short_name || "";

    const city = getComponent("locality") || getComponent("postal_town") || "";
    const state = getComponent("administrative_area_level_1");
    const country = getComponent("country");
    const postalCode = getComponent("postal_code");

    const FormData = {
      venueCode: values.venueCode,
      venueName: values.venueName,
      clientEntityId: entityName,
      contactNo: values.contact,
      emailId: values.email,
      address: values.address,
      city: city,
      state: state,
      postalCode: postalCode,
      country: country,
      lat: latNew,
      long: lngNew,
      feedbackEmail: values.feedbackEmail,
      auditEmail: values.auditEmail,
      fixItEmail: values.fixItEmail,
      reportEmail: values.reportEmail,
      // venueDescription: editorValue,
      shopTypeId: hotelType,
      tradingHours: values.tradingHours,
      venueAdditionalInfo: values.venueAdditionalInfo,
      websiteURL: values.website,
      venuePrice: values.venuePrice,
      venuePriceDisplay: values.venuePriceDisplay,
      venueNumber: values.venueNo,
      venueGroup: values.venueGroup,
      venueMessage: sanitizeEditorContent(venueMessage),
      directorName: values.director,
      executiveManager: values.executiveManager,
      regionId: regionName,
      pdfDescription: values.pdfDescription,
      briefJson: values.briefJson,
      areaIds:values.areaIds,
      logoUrl: logoUrl,
      starRating: values.starRatings,
      createdBy: Number(localStorage.getItem("createdBy")),
      locationType: values.locationType,
      isAutoApproveDateChange: values.isAutoApproveDateChange,
      venueOpen: values.venueOpen.replaceAll("/", "-") + " 00:00:00",
      venueClose: values.venueClose.replaceAll("/", "-") + " 00:00:00",
      sampleReportUrl: uploadedFiles.join(","),
      isEnableManagerScenarioDiscussion: values.isEnableManagerScenarioDiscussion,
    };
    try {
      const response = await ApiPostCreateVenue(FormData);
      toast.success("Venue added successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Error adding Venue:", error);
      toast.error(error);
    }
  };
  const handleUpdateVenue = async (values: any) => {
    // Extracting values from address_components
    const components = mapAddress?.address_components;

    const getComponent = (type: string) =>
      components?.find((c) => c.types.includes(type))?.short_name || "";

    const city = getComponent("locality") || getComponent("postal_town") || "";
    const state = getComponent("administrative_area_level_1");
    const country = getComponent("country");
    const postalCode = getComponent("postal_code");

    const FormData = {
      venueId: venue.venueId,
      venueCode: values.venueCode,
      venueName: values.venueName,
      clientEntityId: entityName,
      contactNo: values.contact,
      emailId: values.email,
      address: values.address,
      city: city != '' ? city : venue?.city,
      state: state != '' ? state : venue?.state,
      postalCode: postalCode != '' ? postalCode : venue?.postalCode,
      country: country != '' ? country : venue?.country,
      lat: latNew != null ? latNew : venue?.lat,
      long: lngNew !== null ? lngNew : venue?.long,
      feedbackEmail: values.feedbackEmail,
      auditEmail: values.auditEmail,
      fixItEmail: values.fixItEmail,
      reportEmail: values.reportEmail,
      // venueDescription: editorValue,
      shopTypeId: hotelType,
      tradingHours: values.tradingHours,
      venueAdditionalInfo: values.venueAdditionalInfo,
      websiteURL: values.website,
      venuePrice: values.venuePrice,
      venuePriceDisplay: values.venuePriceDisplay,
      venueNumber: values.venueNo,
      venueGroup: values.venueGroup,
      venueMessage: sanitizeEditorContent(venueMessage),
      directorName: values.director,
      executiveManager: values.executiveManager,
      regionId: regionName,
      pdfDescription: values.pdfDescription,
      briefJson: values.briefJson,
      areaIds:values.areaIds,
      logoUrl: logoUrl,
      starRating: values.starRatings,
      createdBy: Number(localStorage.getItem("createdBy")),
      updatedBy: Number(localStorage.getItem("createdBy")),
      locationType: values.locationType,
      isAutoApproveDateChange: values.isAutoApproveDateChange,
      venueOpen: values.venueOpen.replaceAll("/", "-") +
        (values.venueOpen.includes("00:00:00") ? "" : " 00:00:00"),
      venueClose: values.venueClose.replaceAll("/", "-") +
        (values.venueClose.includes("00:00:00") ? "" : " 00:00:00"),
      sampleReportUrl: uploadedFiles.join(","),
      isEnableManagerScenarioDiscussion: values.isEnableManagerScenarioDiscussion
      // venueOpen:values.venueOpen.replaceAll("/", "-") + "00:00:00",
      // venueClose:values.venueClose.replaceAll("/", "-") + "00:00:00",
    };
    // console.log("Values --->", FormData)
    try {
      const response = await ApiPutUpdateVenue(FormData);
      toast.success("Venue updated successfully!");
      navigate(-1);
    } catch (error) {
      console.error("Error adding Venue:", error);
    }
  };

  const validationSchema: Yup.ObjectSchema<FormValues> = Yup.object({
    entityName: Yup.string().required("Business type is required"),
    hotelType: Yup.string().required("Shop type is required"),
    venueName: Yup.string().required("Venue name is required"),
    venueCode: Yup.string().optional(),
    // contact: Yup.string().required("Contact is required"),
    email: Yup.string().optional(),
    // .email("Invalid email address")
    // .required("Email is required"),
    locationType: Yup.string().required("Location type is required"),
    venuePrice: Yup.string().required("Venue price is required"),

    // starRatings: Yup.array().required( "Star Rating is required")
  });

  const uploadImage = async (file: File) => {
    store.dispatch(setLoadingTrue());
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileType", "venue_logo");
    if (mode === "update") {
      formData.append("venueId", venue.venueId);
    }

    try {
      const response = await CustomUploadProfilePic(formData);
      store.dispatch(setLoadingFalse());
      toast.success("File uploaded successfully");
      setLogoUrl(response.location);
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error(error);
    }
  };
  if (mapAddress) {
    const addressComponents = mapAddress
      ? mapAddress.address_components
      : undefined;
    // Extracting values from address_components
    const formattedAddress = addressComponents
      ? addressComponents
        .slice(0, 3) // First 3 values for address
        .map((component) => component.short_name)
        .join(", ")
      : null;
  }

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files ? event.target.files[0] : null;
    if (file) {
      store.dispatch(setLoadingTrue());
      try {
        // Compression options
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        // Show preview
        const fileReader = new FileReader();
        fileReader.onloadend = () => {
          setPreview(fileReader.result as string);
        };
        fileReader.readAsDataURL(compressedFile);

        // Upload compressed file
        uploadImage(compressedFile);
      } catch (error) {
        console.error("Image compression failed:", error);
      }
    }
  };

  const handleCopyLogo = async () => {
    if (!entityName) {
      toast.info("Please select a Business before copying the logo.");
      return;
    }

    if (!logoUrl) {
      toast.info("Please upload a logo first.");
      return;
    }
    try {
      const data = {
        clientEntityId: entityName,
        logoUrl: logoUrl
      }
      const res = await ApiCopyLogo(data);
      toast.success(res.message)
    } catch (error) {
      console.error("Error Copying Logo.", error);
      toast.error("Error Copying Logo.")
    }
  }

  const handleCopyDateRequest = async () => {
    if (!entityName) {
      toast.info("Please select a Business first.");
      return;
    }

    try {
      const data = {
        clientEntityId: entityName,
        isAutoApproveDateChange: formValues.isAutoApproveDateChange,
      };

      const res = await ApiCopyDateRequest(data);
      toast.success(res.message);
    } catch (error) {
      console.error("Error copying date request", error);
      toast.error("Error copying date request");
    }
  };


  const handleRemoveFile = (index: number) => {
    setUploadedFiles(prev => {
      const updatedFiles = [...prev];
      updatedFiles.splice(index, 1);
      return updatedFiles;
    });
  };


  const uploadDocumentImage = async (file: File) => {
    store.dispatch(setLoadingTrue())
    const formData = new FormData()
    const userId: any = localStorage.getItem('userId')
    formData.append("file", file)
    formData.append("fileType", "project_static_files")
    formData.append("userId", userId)

    try {
      const response = await CustomUploadProfilePic(formData)
      store.dispatch(setLoadingFalse())
      toast.success(response.message)
      // Add the uploaded file URL to the state
      setUploadedFiles(prev => [...prev, response.location]);
    } catch (error) {
      console.error("Error uploading file:", error)
      toast.error("Error Uploading File")
    }
  }


  const handleDocumentUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null
    if (file) {
      store.dispatch(setLoadingTrue())
      try {
        await uploadDocumentImage(file)
      } catch (error) {
        console.error("Image upload failed:", error)
      }
    }
  }

  return (
    <Formik
      initialValues={formValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values) => {
        if (mode === "add") {
          handleAddVenue(values);
        } else {
          handleUpdateVenue(values);
        }
      }}
    >
      {({
        handleChange,
        handleBlur,
        values,
        errors,
        touched,
        handleSubmit,
        isSubmitting,
        setFieldValue,
      }) => {
        // Store setFieldValue in ref so it can be accessed in useEffect
        setFieldValueRef.current = setFieldValue;

        return (
          <Form
            className="add-new-site m-2 py-3 border-10"
            style={{ background: "white" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
              }
            }}
          >
            <h1 className="common-add mb-5">
              {mode === "add" ? "Add New Site" : "Update Site"}
            </h1>

            <Box
              className='px-2'
              sx={{ padding: "20px 0px", width: "100%", paddingBottom: "0px" }}
            >
              {[
                {
                  label: "",
                  name: "entityName",
                  type: "entityName",
                },
                {
                  label: "",
                  name: "hotelType",
                  type: "hotelType",
                },
                { label: "Venue Name", name: "venueName", type: "text" },
                { label: "Venue Code", name: "venueCode", type: "text" },
                { label: "Venue No", name: "venueNo", type: "text" },
                { label: "Venue Group", name: "venueGroup", type: "text" },
                { label: "Venue Message", name: "venueMessage", type: "venueMessage" },
                {
                  label: "Venue Close Date",
                  name: "venueClose",
                  type: "date",
                },
                {
                  label: "Venue Open Date",
                  name: "venueOpen",
                  type: "date",
                },
                { label: "Contact", name: "contact", type: "text" },
                { label: "Address", name: "address", type: "address" },
                { label: "Latitude", name: "lat", type: "lat" },
                { label: "Longitude", name: "long", type: "long" },
                { label: "Map", name: "", type: "googleMap" },
                { label: "Email", name: "email", type: "text" },
                {
                  label: "Feedback Email",
                  name: "feedbackEmail",
                  type: "text",
                },
                { label: "Audit Email", name: "auditEmail", type: "text" },
                { label: "Fix It Email", name: "fixItEmail", type: "text" },
                { label: "Report Email", name: "reportEmail", type: "text" },
                // {
                //   label: "Task Brief",
                //   name: "venueDescription",
                //   type: "Description",
                // },
                { label: "Trading Hours", name: "tradingHours", type: "text" },
                { label: "Additional Info", name: "venueAdditionalInfo", type: "text" },

                { label: "Website", name: "website", type: "text" },
                { label: "Venue Price", name: "venuePrice", type: "number" },
                {
                  label: "Venue Price Display",
                  name: "venuePriceDisplay",
                  type: "text",
                },
                {
                  label: "Director",
                  name: "director",
                  type: "text",
                },
                {
                  label: "Area Manager",
                  name: "executiveManager",
                  type: "text",
                },
                {
                  label: "Region",
                  name: "region",
                  type: "region",
                },
                {
                  label: "PDF Description",
                  name: "pdfDescription",
                  type: "textarea",
                },
                { label: "Overview prompts", name: "briefJson", type: "Brief" },
                { label: "Area Managers", name: "areaIds", type: "Area" },
                // { label: "Address", name: "mapaddress", type: "text" },
                { label: "Star Ratings", name: "starRatings", type: "string" },
                { label: "Can date change request auto approve ?", name: "isAutoApproveDateChange", type: "switch" },
                { label: "Is Staff Member Cues Discussion ?", name: "isEnableManagerScenarioDiscussion", type: "switch" },
                { label: "Sample Report", name: "sampleReportUrl", type: "file" },
              ].map(({ label, name, type }) => (
                <Box
                  key={name}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: { xs: "column", md: "row" },
                    marginBottom: "15px",
                    width: "100%",
                  }}
                >
                  <label
                    htmlFor={name}
                    className="form-label"
                    style={{
                      marginRight: "10px",
                      minWidth: "200px",
                    }}
                  >
                    {label}
                    {type === "entityName" || type === "hotelType" ? "" : ":"}
                  </label>
                  {type === "entityName" ? (
                    <Box
                      sx={{
                        width: { xs: "100%", md: "calc(100% - 220px)" },
                        marginBottom: "-15px",
                      }}
                    >
                      <Autocomplete
                        disabled={mode === "update"}
                        className="mb-3"
                        disablePortal
                        id="mm-autocomplete"
                        options={Clientlist}
                        value={selectedClient}
                        getOptionLabel={(option) => option?.clientGroupName}
                        isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                        onChange={(event, newValue: any) => {
                          // setSelectedClient(newValue)
                          dispatch(setSelectedClientGroup(newValue))
                          setClientId(newValue?.clientGroupName || null)
                          if (
                            !newValue ||
                            (selectedClient && newValue.clientGroupName !== selectedClient.clientGroupName)
                          ) {
                            // setClientEntity(null)
                            setRegionName(null)
                            setEntityName(null)
                          }
                        }}
                        defaultValue="mmcommon"
                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                      // size="small"
                      />

                      <Autocomplete
                        options={clientEntity}
                        value={
                          clientEntity.find(
                            (option: any) => option.value === entityName
                          ) || null
                        }
                        getOptionLabel={(option: any) => option.label}
                        onChange={(_, newValue) => {
                          handleEntityChange(newValue);
                          handleChange({
                            target: {
                              name: "entityName",
                              value: newValue?.value || "",
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            label="Select Business"
                            error={
                              touched.entityName && Boolean(errors.entityName)
                            }
                            helperText={
                              touched.entityName && errors.entityName
                                ? String(errors.entityName)
                                : ""
                            }
                          />
                        )}
                        fullWidth
                        disabled={mode === "update"}
                      />
                    </Box>
                  ) : type === "hotelType" ? (
                    <Autocomplete
                      options={entityType}
                      sx={{ width: { xs: "100%", md: "calc(100% - 220px)" }, marginTop: "15px" }}
                      value={
                        entityType.find(
                          (option) => option.value === hotelType
                        ) || null
                      }
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setHotelType(newValue.value);
                          handleChange({
                            target: {
                              name: "hotelType",
                              value: newValue.value,
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required={mode === "update" ? false : true}
                          error={touched.hotelType && Boolean(errors.hotelType)}
                          helperText={
                            touched.hotelType && errors.hotelType
                              ? String(errors.hotelType)
                              : ""
                          }
                          label="Select Shop Type"
                        />
                      )}
                      fullWidth
                      disabled={mode === "update"}
                    />
                  ) : type === "region" ? (
                    <Autocomplete
                      options={regions}
                      sx={{ width: { xs: "100%", md: "calc(100% - 220px)" }, marginTop: "15px" }}
                      value={
                        regions.find((option) => option.value === regionName) ||
                        null
                      }
                      getOptionLabel={(option) => option.label}
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setRegionName(newValue.value);
                          handleChange({
                            target: {
                              name: "region",
                              value: newValue?.value || "",
                            },
                          });
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Region"
                        />
                      )}
                      fullWidth
                    />
                  ) : type === "Brief" ? (
                    <Box sx={{ width: { xs: "100%", md: "100%" } }}>
                      {/* <Autocomplete
                        multiple
                        options={briefJsonNew}
                        value={briefJsonNew.filter((editor) =>
                          values.briefJson
                            .split(",")
                            .map((val) => val.trim())
                            .includes(String(editor.value))
                        )}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                          <Tooltip title={option?.description}>
                            <li {...props}>
                              <span style={{ marginRight: 12 }}>
                                {option.label}
                              </span>

                              <span className="text-danger" style={{ marginRight: 12, fontSize: '14px', fontWeight: 'bold' }}>
                                Min: {option.min}, Max: {option.max},
                              </span>
                              <span style={{ fontSize: '14px' }}>
                                <b className="text-danger">Description:{" "}</b>
                                {option.description?.split(" ").slice(0, 20).join(" ")}
                                {option.description?.split(" ").length > 20 && " ..."}
                              </span>
                            </li>
                          </Tooltip>
                        )}
                        onChange={(event, newValue) => {
                          const selectedValues = newValue.map(
                            (option) => option.value
                          );
                          handleChange({
                            target: {
                              name: "briefJson",
                              value: selectedValues.join(","),
                            },
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select briefJson"
                            fullWidth
                          />
                        )}
                      /> */}
                      <Tooltip title=''>
                        <Autocomplete
                          multiple
                          options={briefJsonNew}
                          sx={{ marginTop: "15px", width: { xs: "100%", md: "100%" } }}
                          value={values.briefJson
                            .split(",")
                            .map((val) => val.trim())
                            .map((val) =>
                              briefJsonNew.find((editor: any) => String(editor.value) === val)
                            )
                            .filter(Boolean)
                          }
                          getOptionLabel={(option) => option.label}
                          renderOption={(props, option) => (
                            <Tooltip title={option?.description}>
                              <li {...props}>
                                <span style={{ marginRight: 12, whiteSpace: "nowrap" }}>
                                  {option.label}
                                </span>

                                <span className="text-danger" style={{ marginRight: 12, fontSize: '14px', fontWeight: 'bold', whiteSpace: "nowrap" }}>
                                  Min: {option.min}, Max: {option.max},
                                </span>
                                <span style={{ fontSize: '14px' }}>
                                  <b className="text-danger">Description:{" "}</b>
                                  {option.description?.split(" ").slice(0, 20).join(" ")}
                                  {option.description?.split(" ").length > 20 && " ..."}
                                </span>
                              </li>
                            </Tooltip>
                          )}

                          renderTags={(value, getTagProps) => (
                            <DndContext
                              collisionDetection={closestCenter}
                              onDragEnd={(event) => {
                                const { active, over } = event;
                                if (active.id !== over?.id) {
                                  const oldIndex = value.findIndex(
                                    (item) => item.value === active.id
                                  );
                                  const newIndex = value.findIndex(
                                    (item) => item.value === over?.id
                                  );

                                  const newOrder = arrayMove(value, oldIndex, newIndex);

                                  const selectedValues = newOrder.map((item) => item.value);

                                  handleChange({
                                    target: {
                                      name: "briefJson",
                                      value: selectedValues.join(","),
                                    },
                                  });
                                }
                              }}
                            >
                              <SortableContext
                                items={value.map((item) => item.value)}
                                strategy={horizontalListSortingStrategy}
                              >
                                {value.map((option, index) => {
                                  const tagProps = getTagProps({ index });
                                  return (
                                    <Tooltip arrow key={index} title={
                                    <div>
                                      <p style={{ margin: 0 }}>{option?.description}</p>
                                      <b>Min:</b> {option?.min} <br />
                                      <b>Max:</b> {option?.max}
                                    </div>
                                  }>
                                      <span>
                                        <SortableChip
                                          key={option.value}
                                          id={option.value}
                                          label={option.label}
                                          onDelete={tagProps.onDelete}
                                        />
                                      </span>
                                    </Tooltip>
                                  )
                                })}
                              </SortableContext>
                            </DndContext>
                          )}

                          onChange={(event, newValue) => {
                            const selectedValues = newValue.map(
                              (option) => option.value
                            );
                            handleChange({
                              target: {
                                name: "briefJson",
                                value: selectedValues.join(","),
                              },
                            });
                          }}

                          renderInput={(params) => (
                            <TextField {...params} label={
                              <Box display="flex" alignItems="center" gap={1}>
                                Select Overview Prompts
                                <Tooltip title="Drag and drop to reorder the selected items.">
                                  <InfoOutlined
                                    fontSize="small"
                                    sx={{ cursor: "pointer", color: "#ADB792" }}
                                  />
                                </Tooltip>
                              </Box>
                            } />
                          )}
                          fullWidth
                        />
                      </Tooltip>
                    </Box>
                  ) : type === "Area" ? (
                    <Box sx={{ width: { xs: "100%", md: "100%" } }}>
                      <Tooltip title=''>
                        <Autocomplete
                          multiple
                          options={areaList}
                          sx={{ marginTop: "15px", width: { xs: "100%", md: "100%" } }}
                          value={values.areaIds
                            .split(",")
                            .map((val) => val.trim())
                            .map((val) =>
                              areaList.find((editor: any) => String(editor.value) === val)
                            )
                            .filter(Boolean)
                          }
                          getOptionLabel={(option) => option.label}
                          renderOption={(props, option) => (
                            <Box>
                              <li {...props}>
                                <span style={{ marginRight: 5, whiteSpace: "nowrap" }}>
                                  {option.label}
                                </span>
                                <span style={{ marginRight: 12, whiteSpace: "nowrap" }}>
                                  ({option.firstName}{option.lastName} - {option?.emailId})
                                </span>

                                {/* <span className="text-danger" style={{ marginRight: 12, fontSize: '14px', fontWeight: 'bold', whiteSpace: "nowrap" }}>
                                  Min: {option.min}, Max: {option.max},
                                </span>
                                <span style={{ fontSize: '14px' }}>
                                  <b className="text-danger">Description:{" "}</b>
                                  {option.description?.split(" ").slice(0, 20).join(" ")}
                                  {option.description?.split(" ").length > 20 && " ..."}
                                </span> */}
                              </li>
                            </Box>
                          )}

                          renderTags={(value, getTagProps) => (
                            <DndContext
                              collisionDetection={closestCenter}
                              onDragEnd={(event) => {
                                const { active, over } = event;
                                if (active.id !== over?.id) {
                                  const oldIndex = value.findIndex(
                                    (item) => item.value === active.id
                                  );
                                  const newIndex = value.findIndex(
                                    (item) => item.value === over?.id
                                  );

                                  const newOrder = arrayMove(value, oldIndex, newIndex);

                                  const selectedValues = newOrder.map((item) => item.value);

                                  handleChange({
                                    target: {
                                      name: "areaIds",
                                      value: selectedValues.join(","),
                                    },
                                  });
                                }
                              }}
                            >
                              <SortableContext
                                items={value.map((item) => item.value)}
                                strategy={horizontalListSortingStrategy}
                              >
                                {value.map((option, index) => {
                                  const tagProps = getTagProps({ index });
                                  return (
                                      <span>
                                        <SortableChip
                                          key={option.value}
                                          id={option.value}
                                          label={option.label}
                                          onDelete={tagProps.onDelete}
                                        />
                                      </span>
                                  )
                                })}
                              </SortableContext>
                            </DndContext>
                          )}

                          onChange={(event, newValue) => {
                            const selectedValues = newValue.map(
                              (option) => option.value
                            );
                            handleChange({
                              target: {
                                name: "areaIds",
                                value: selectedValues.join(","),
                              },
                            });
                          }}

                          renderInput={(params) => (
                            <TextField {...params} label={
                              <Box display="flex" alignItems="center" gap={1}>
                                Select Overview Prompts
                                <Tooltip title="Drag and drop to reorder the selected items.">
                                  <InfoOutlined
                                    fontSize="small"
                                    sx={{ cursor: "pointer", color: "#ADB792" }}
                                  />
                                </Tooltip>
                              </Box>
                            } />
                          )}
                          fullWidth
                        />
                      </Tooltip>
                    </Box>
                  )  : type === "Description" ? (
                    <PatchedReactQuill
                      setEditorValue={setEditorValue}
                      editorValue={editorValue}
                      isUpdate={mode === "update" ? true : false}
                    />
                  ) : type === "venueMessage" ? (
                    <PatchedReactQuill
                      setEditorValue={setVenueMessage}
                      editorValue={venueMessage}
                      isUpdate={false}
                    />
                  )
                    : type === "textarea" ? (
                      <TextField
                        // as="textarea"
                        type="textarea"
                        id={name}
                        name={name}
                        sx={{ width: { xs: "100%", md: "calc(100% - 220px)" } }}
                        value={values[name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    ) : type === "checkbox" ? (
                      <TextField
                        type="checkbox"
                        id={name}
                        name={name}
                        sx={{ width: { xs: "100%", md: "calc(100% - 220px)" }, margin: "0 10px" }}
                        checked={values[name]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    ) : type === "lat" ? (
                      <TextField
                        type={type}
                        name={name}
                        sx={{
                          width: { xs: "100%", md: "calc(100% - 220px)" },
                          padding: "5px",
                        }}
                        value={latNew}
                      />
                    ) : type === "long" ? (
                      <TextField
                        type={type}
                        name={name}
                        sx={{
                          width: { xs: "100%", md: "calc(100% - 220px)" },
                          padding: "5px",
                        }}
                        value={lngNew}
                      />
                    ) : type === "address" ? (
                      <TextField
                        inputRef={inputRef}
                        type="text"
                        name={name}
                        value={values[name] || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter address"
                        sx={{ "& .MuiOutlinedInput-root": { padding: "5px" }, width: { xs: "100%", md: "calc(100% - 220px)" } }}
                      />
                    ) : type === "number" ? (
                      <Box sx={{ width: { xs: "100%", md: "calc(100% - 220px)" } }}>
                        <TextField
                          type={type}
                          id={name}
                          name={name}
                          style={{
                            width: "calc(100% - 220px)",
                            padding: "5px",
                          }}
                          value={values[name]}
                          min="0"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (
                              value === "" ||
                              (Number(value) >= 0 && /^\d*$/.test(value))
                            ) {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                        />
                        {name === "venuePrice" &&
                          touched.venuePrice &&
                          errors.venuePrice && (
                            <div
                              style={{
                                color: "#d32f2f",
                                fontSize: "12px",
                                marginLeft: "15px",
                              }}
                            >
                              {String(errors.venuePrice)}
                            </div>
                          )}
                      </Box>
                    ) : type === "googleMap" ? (
                      // <GoogleMapDialog
                      //   setLat={setLat}
                      //   lat={latNew}
                      //   lng={lngNew}
                      //   setLng={setLng}
                      //   setAddress={setAddress}
                      //   isReadOnly = {false}
                      // />
                      <Box
                        sx={{
                          width: { xs: "100%", md: "calc(100% - 220px)" },
                          position: "relative",
                        }}
                      >
                        {/* <input
                          id="search-input"
                          type="text"
                          placeholder="Search location"
                          style={{
                            width: "30%",
                            padding: "7px",
                            marginBottom: "10px",
                            border: "1px solid rgb(204, 204, 204)",
                            borderRadius: "4px",
                            position: "absolute",
                            zIndex: 999,
                            top: "10px",
                            left: "194px",
                          }}
                        /> */}
                        <GoogleMap
                          mapContainerStyle={containerStyle}
                          center={center}
                          zoom={4.5}
                        >
                          <Marker
                            key={latNew}
                            position={{ lat: latNew, lng: lngNew }}
                          ></Marker>
                        </GoogleMap>
                      </Box>
                    ) : type === "string" ? (
                      // <Autocomplete
                      //   multiple
                      //   options={starRatingList}
                      //   sx={{ marginTop: "15px", width: { xs: "100%", md: "calc(100% - 220px)" } }}
                      //   value={starRatingList.filter((option) =>
                      //     values.starRatings
                      //       .split(",")
                      //       .map((val) => val.trim())
                      //       .includes(String(option.value))
                      //   )}
                      //   getOptionLabel={(option) => option.label}
                      //   onChange={(event, newValues) => {
                      //     console.log(newValues);
                      //     const selectedValues = newValues.map(
                      //       (option) => option.value
                      //     ); // ✅ Convert to comma-separated string

                      //     handleChange({
                      //       target: {
                      //         name: "starRatings",
                      //         value: selectedValues.join(","),
                      //       },
                      //     });
                      //   }}
                      //   renderInput={(params) => (
                      //     <TextField
                      //       {...params}
                      //       label="Select Star Ratings"
                      //       error={
                      //         touched.starRatings && Boolean(errors.starRatings)
                      //       } // ✅ Pass error to TextField
                      //       helperText={
                      //         touched.starRatings && errors.starRatings
                      //           ? String(errors.starRatings)
                      //           : ""
                      //       } // ✅ Pass helper text to TextField
                      //     />
                      //   )}
                      //   fullWidth
                      // />

                      <Autocomplete
                        multiple
                        id="star-ratings-multiple"
                        options={starRatingList?.filter((item: any) => !item?.isDisabled)}
                        sx={{
                          marginTop: "15px",
                          width: { xs: "100%", md: "calc(100% - 220px)" },
                        }}

                        value={values.starRatings
                          ?.split(",")
                          .map((val) => val.trim())
                          .map((val) =>
                            starRatingList.find(
                              (option) => String(option.value) === val
                            )
                          )
                          .filter(Boolean)
                        }

                        getOptionLabel={(option) => option.label}

                        renderTags={(value, getTagProps) => (
                          <DndContext
                            collisionDetection={closestCenter}
                            onDragEnd={(event) => {
                              const { active, over } = event;
                              if (over && active.id !== over.id) {
                                const oldIndex = value.findIndex(
                                  (item) => item.value === active.id
                                );
                                const newIndex = value.findIndex(
                                  (item) => item.value === over.id
                                );

                                const newOrder = arrayMove(value, oldIndex, newIndex);

                                const selectedValues = newOrder.map(
                                  (item) => item.value
                                );

                                handleChange({
                                  target: {
                                    name: "starRatings",
                                    value: selectedValues.join(","),
                                  },
                                });
                              }
                            }}
                          >
                            <SortableContext
                              items={value.map((item) => item.value)}
                              strategy={horizontalListSortingStrategy}
                            >
                              {value.map((option, index) => {
                                const tagProps = getTagProps({ index });
                                return (
                                  <SortableChip
                                    key={option.value}
                                    id={option.value}
                                    label={option.label}
                                    onDelete={tagProps.onDelete}
                                  />
                                )
                              })}
                            </SortableContext>
                          </DndContext>
                        )}

                        onChange={(event, newValues) => {
                          const selectedValues = newValues.map(
                            (option) => option.value
                          );
                          handleChange({
                            target: {
                              name: "starRatings",
                              value: selectedValues.join(","),
                            },
                          });
                        }}

                        renderInput={(params) => (
                          <TextField {...params} label={
                            <Box display="flex" alignItems="center" gap={1}>
                              Select Star Ratings
                              <Tooltip title="Drag and drop to reorder the selected items.">
                                <InfoOutlined
                                  fontSize="small"
                                  sx={{ cursor: "pointer", color: "#ADB792" }}
                                />
                              </Tooltip>
                            </Box>
                          } />
                        )}

                        fullWidth
                      />
                    ) : type === 'switch' ? (
                      <Box
                        sx={{
                          width: { xs: "100%", md: "calc(100% - 280px)" },
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch checked={values[name]} onChange={handleChange} name={name} />
                          }
                          label=''
                        />
                       {name === "isAutoApproveDateChange" && ( <Button
                          style={{ padding: "9px 70px" }}
                          variant="contained"
                          color="primary"
                          className="table-row-background"
                          onClick={() => {
                            const isConfirmed = window.confirm(
                              "Are you sure you want to copy date request setting to all venues?"
                            );
                            if (isConfirmed) {
                              handleCopyDateRequest();
                            }
                          }}
                        >
                          Copy Date Change Request to all sites
                        </Button>
                        )}
                      </Box>
                    ) : type === "date" ? (
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                          label={label}
                          value={name === "venueOpen" ? venueOpenDate : venueCloseDate}
                          onChange={(newDate) => {
                            if (name === "venueOpen") {
                              setVenueOpenDate(newDate);
                            } else {
                              setVenueCloseDate(newDate);
                            }
                            const formattedDate = newDate ? format(newDate, 'yyyy/MM/dd') : '';
                            setFieldValue(name, formattedDate);
                          }}
                          format="dd/MM/yyyy"
                          sx={{
                            width: { xs: "100%", md: "calc(100% - 220px)" },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: 1,
                            }
                          }}
                        />
                      </LocalizationProvider>
                    ) : type === "file" ?
                      (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: { xs: "column", md: "row" },
                            marginBottom: "15px",
                            width: "100%",
                          }}
                        >
                          {/* <label
                            style={{
                              marginRight: "10px",
                              minWidth: "200px",
                              textAlign: "right",
                            }}
                          >
                            Sample Report:
                          </label> */}
                          <FormControl className='mt-3' fullWidth>
                            <Grid container className='w-100' spacing={2}>
                              {uploadedFiles.map((fileUrl, index) => (
                                <Grid size={12} key={index}>
                                  <Box
                                    className='w-100'
                                    sx={{
                                      position: 'relative',
                                      border: '2px dashed #ccc',
                                      borderRadius: '10px',
                                      overflow: 'hidden',
                                      height: '150px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      flexDirection: 'column',
                                      p: 2
                                    }}
                                  >
                                    {fileUrl.includes(".pdf") ? (
                                      <PictureAsPdfOutlined color="error" fontSize="large" />
                                    ) : fileUrl.includes(".xlsx") || fileUrl.includes(".xls") ? (
                                      <DescriptionOutlined color="success" fontSize="large" />
                                    ) : (
                                      <InsertDriveFileOutlined color="action" fontSize="large" />
                                    )}

                                    <Typography
                                      variant="body2"
                                      noWrap
                                      sx={{
                                        maxWidth: '100%',
                                        mt: 1,
                                        textDecoration: 'underline',
                                        color: 'primary.main',
                                        cursor: 'pointer'
                                      }}
                                      onClick={() => window.open(fileUrl, '_blank')}
                                    >
                                      {fileUrl.split('/').pop()}
                                    </Typography>

                                    <IconButton
                                      onClick={() => handleRemoveFile(index)}
                                      sx={{
                                        position: 'absolute',
                                        top: 5,
                                        right: 5,
                                        bgcolor: 'white',
                                        '&:hover': { bgcolor: 'grey.100' },
                                      }}
                                    >
                                      <CancelOutlined color="error" />
                                    </IconButton>
                                  </Box>
                                </Grid>
                              ))}

                              {uploadedFiles.length === 0 && (
                                <Grid size={12}>
                                  <label htmlFor="help_document" className="w-100" style={{ fontSize: '14px', color: 'grey' }}>
                                    <Box
                                      className="d-flex flex-column align-items-center justify-content-center p-5 w-100"
                                      sx={{
                                        border: '2px dashed #ccc',
                                        borderRadius: '10px',
                                        position: 'relative',
                                        height: '150px'
                                      }}
                                    >
                                      <input
                                        type="file"
                                        style={{ opacity: 0, position: 'absolute' }}
                                        className="w-100 h-100"
                                        id="help_document"
                                        onChange={handleDocumentUpload}
                                      />
                                      <Upload />
                                      <div>Upload Here</div>
                                    </Box>
                                  </label>
                                </Grid>
                              )}
                            </Grid>
                          </FormControl>
                        </Box>
                      )
                      : (
                        <Box sx={{ width: { xs: "100%", md: "calc(100% - 220px)" } }}>
                          <Field
                            type={type}
                            id={name}
                            name={name}
                            style={{
                              width: "100%",
                              padding: "5px",
                            }}
                            value={values[name]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            // required={
                            //   name === "venueName" ||
                            //     // name === "venueCode" ||
                            //     name === "contact" ||
                            //     name === "email"
                            //     ? true
                            //     : false
                            // }
                            className={`${
                                    (name === "venueName" &&
                                      errors.venueName &&
                                      touched.venueName) ||
                                    (name === "venueCode" &&
                                      errors.venueCode &&
                                      touched.venueCode) ||
                                    (name === "contact" &&
                                      errors.contact &&
                                      touched.contact) ||
                                    (name === "email" && errors.email && touched.email)
                                    ? "border-rad"
                                    : ""
                                  } `}
                          />
                          {["venueName", "contact", "email"].map(
                            (field) =>
                              name === field &&
                              touched[field] &&
                              errors[field] && (
                                <div
                                  key={field}
                                  style={{
                                    color: "#d32f2f",
                                    fontSize: "12px",
                                    marginLeft: "15px",
                                  }}
                                >
                                  {String(errors[field])}
                                </div>
                              )
                          )}
                        </Box>
                      )}
                </Box>
              ))}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "15px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="venueLogo"
                  className="form-label"
                  style={{
                    marginRight: "10px",
                    minWidth: "200px",

                  }}
                >
                  Venue Logo:
                </label>
                <TextField
                  type="file"
                  inputProps={{ accept: "image/*" }}
                  onChange={(event) => {
                    handleImageChange(event);
                  }}
                  sx={{ width: { xs: "100%", md: "calc(100% - 220px)" } }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "15px",
                  width: "100%",
                }}
              >
                <label
                  htmlFor="locationType"
                  className="form-label"
                  style={{
                    marginRight: "10px",
                    minWidth: "200px",
                  }}
                >
                  Location Type:
                </label>
                <FormControl
                  error={touched.locationType && Boolean(errors.locationType)}
                  sx={{ width: { xs: "100%", md: "calc(100% - 220px)" } }}
                >
                  <RadioGroup
                    style={{
                      display: "flex",
                      gap: "0px",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                    name="locationType"
                    value={values.locationType}
                    onChange={(e) => {
                      setFieldValue("locationType", e.target.value);
                    }}
                  >
                    <Radio value="city" />
                    Metro
                    <Radio style={{ marginLeft: "20px" }} value="region" />
                    Regional
                  </RadioGroup>
                  {touched.locationType && errors.locationType && (
                    <FormHelperText
                      style={{ color: "#d32f2f", marginLeft: "0" }}
                    >
                      {String(errors.locationType)}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>

              {logoUrl && (
                <div style={{ margin: "20px" }} className="text-center">
                  <img
                    src={logoUrl || "/placeholder.svg"}
                    alt="Venue Logo Preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              )}

              <Box className="text-center d-flex justify-content-center" gap={2}>
                <Button
                  style={{ padding: "9px 70px" }}
                  type="submit"
                  // onClick={handleSubmit}
                  variant="contained"
                  color="primary"
                  className="table-row-background"
                // disabled={isSubmitting}
                >
                  {mode === "add" ? "Add Site" : "Update Site"}
                </Button>
                <Button
                  style={{ padding: "9px 70px" }}
                  variant="contained"
                  color="primary"
                  className="table-row-background"
                  onClick={() => {
                    const isConfirmed = window.confirm("Are you sure you want to Copy Logo To all Venue?")
                    if (isConfirmed) {
                      handleCopyLogo()
                    }
                  }}
                >
                  Copy logo to all sites
                </Button>
              </Box>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AddOrUpdateVenue;
